import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/app';
import './shared-assets/index.scss';

ReactDOM.render(<App />, document.getElementById('root'));
